import * as React from "react";
import * as classnames from "classnames";
var Spinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.centered, centered = _c === void 0 ? false : _c;
    return (React.createElement("svg", { className: classnames("wds-spinner wds-spinner--" + size, {
            "sui-spinner-center": centered
        }), viewBox: "25 25 50 50" },
        React.createElement("circle", { className: "wds-spinner__path-border", cx: "50", cy: "50", r: "20" }),
        React.createElement("circle", { className: "wds-spinner__path-fill", cx: "50", cy: "50", r: "20" })));
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Spinner/Spinner.js
// module id = 1809
// module chunks = 17